var _path, _circle, _circle2, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPermanentObstacle = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 137,
    viewBox: "0 0 34 137",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 134.677V136.677H2V110.177H33V136.677H29V134.677H6Z",
    stroke: "black",
    strokeWidth: 0.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 3.5,
    cy: 108.177,
    r: 1.25,
    stroke: "black",
    strokeWidth: 0.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 31.5,
    cy: 108.177,
    r: 1.25,
    stroke: "black",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 110.177V100.177L15 95.1772V89.1772L16 82.6772V77.1772V71.1772H17.5V77.1772V82.6772L16.5 89.1772V95.1772L17.5 100.177V110.177",
    stroke: "black",
    strokeWidth: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 67.6772L13.5 70.6772L15 71.1772L18.5 70.6772C19.5 70.1772 21.5 68.9772 21.5 68.1772C21.5 67.3772 24.1667 64.8439 25.5 63.6772C26.3333 61.0106 28 55.4772 28 54.6772C28 53.6772 28.5 49.1772 28.5 47.6772C28.5 46.1772 29.0615 44.3699 29.5 42.1772C30 39.6772 30 39.1772 30 37.1772C30 35.5961 30.2712 31.7619 30 30.6772C29.5 28.6772 29.5 27.6772 29 26.6772C28.5 25.6772 28.5 23.1772 28.5 21.6772C28.5 20.1772 29 18.6772 28.5 16.1772C28 13.6772 27.5 13.1772 27 11.6772C26.5 10.1772 25 8.67723 23.5 6.67723C23.0757 6.11155 22.5 4.67725 21 3.67723L19.5 2.17725L17.5 1.17723C14 0.677246 14.0804 1.20177 12.5 3.17723C10.5 5.67723 11.5 5.67723 10.5 6.67723C9.70943 7.4678 9 8.67723 8.5 9.17723C8 9.67723 7 13.1772 6.5 14.6772C6 16.1772 5.5 17.6772 5 18.6772C4.6 19.4772 2.83333 24.3439 2 26.6772C1.66667 29.0106 1 34.1772 1 36.1772C1 38.6772 1 41.6772 1.5 44.1772C2 46.6772 3 48.6772 3 49.1772C3 49.6772 3.5 54.1772 3.5 55.6772C3.5 57.1772 4.5 58.6772 5 59.6772C5.4 60.4772 6.16667 61.6772 6.5 62.1772L9.5 67.6772Z",
    stroke: "black",
    strokeWidth: 0.5
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPermanentObstacle);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/permanentObstacle.0a9cf41762d5fe45938b0e85b83a1ba8.svg";